export enum CfiAssessmentPersonalityEnum {
  CONQUEROR = 'CONQUEROR',
  PROTECTOR = 'PROTECTOR',
  GAMBLER = 'GAMBLER',
  INVESTIGATOR = 'INVESTIGATOR',
  ARTIST = 'ARTIST',
}
